import { format } from 'date-fns'

/**
 * Returns true if date is between May 1 -> Aug 1
 */
export function isWithinNorthAmericanSummer(date: Date) {
  const mayMonth = 4
  const augMonth = 7
  const month = date.getMonth()
  return month >= mayMonth && month < augMonth
}

/**
 * Format a date to a string that is friendly with excel, and unambiguous between locales. Intended for exports.
 */
export function formatExcel(date: Date) {
  return format(date, 'yyyy/MM/dd HH:mm:ss')
}
